import './components/modernizr';
import './components/base';
import './components/bootstrap';
import './components/form';
import './components/loadmore';
import './components/menu';
import './components/menu-fixed';
import {createModal} from './components/popup';
import './components/photoswipe';
import './components/slider';
import {slideToggle} from './components/slides-toggle';

let iframes = document.getElementsByClassName('iframe-maps');
for(let i = 0; i < iframes.length; i++) {
	iframes[i].addEventListener("click", function() {
		let iframe = createIframeGoogleMaps(this.dataset.googleMaps);
		createModal('Showroom mb2 - Google Maps', iframe);
	});
}

function createIframeGoogleMaps(mapsUrl) {
	let iframe = document.createElement('iframe');

	iframe.classList.add('w-100', 'border-0');
	iframe.setAttribute('src', mapsUrl);
	iframe.setAttribute('height', '450');
	iframe.setAttribute('allowfullscreen', '');
	iframe.setAttribute('loading', 'lazy');
	iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');

	return iframe;
}

let faqQuestion = document.getElementsByClassName('faq-question');
for(let i = 0; i < faqQuestion.length; i++) {
	faqQuestion[i].addEventListener("click", function() {
		this.classList.toggle('show');
		this.classList.toggle('text-pink');
		slideToggle(document.getElementById(this.dataset.answerTarget), 250);
	});
}

const leBonSiegeMenu = document.getElementById('menu-item-209');
leBonSiegeMenu.firstChild.setAttribute('target', '_blank');

let marques = document.querySelectorAll('.carousel .carousel-item')
marques.forEach((el) => {
	const minPerSlide = 4
	let next = el.nextElementSibling
	for (var i=1; i<minPerSlide; i++) {
		if (!next) {
			// wrap carousel by using first child
			next = marques[0]
		}
		let cloneChild = next.cloneNode(true)
		el.appendChild(cloneChild.children[0])
		next = next.nextElementSibling
	}
});

let tables = document.querySelectorAll('.wysiwyg table');
tables.forEach((table) => {
	let openDiv = document.createElement('div');
	openDiv.classList.add('table-responsive');
	table.classList.add('table');

	table.parentNode.insertBefore(openDiv, table);
	openDiv.appendChild(table);
});
